import { FC } from "react";
import { SelectBox } from "./SelectBtn.styled";
import { useTranslation } from "../../../hooks/useTranslation";

type Props = {
  onChange: (value: number) => void;
  options: unknown[];
};

export const SelectBtn: FC<Props> = ({ onChange, options }) => {
  const { t } = useTranslation();

  return (
    <SelectBox
      options={options}
      placeholder={t("selectAnswer")}
      className="basic-single"
      classNamePrefix="select"
      maxMenuHeight={172}
      theme={(theme: any) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: "rgba(255, 255, 255, 0.07)",
          primary: `var(--bg-button)`,
        },
      })}
      onChange={(value: any) => onChange(value.value)}
    />
  );
};
